export const PAGE_NOT_FOUND = 'ninpath/containers/ErrorPage/PAGE_NOT_FOUND';
